module.exports = __webpack_public_path__ + "img/sand-decal-28.4e968fd4.png";